import React, { useEffect, useState } from "react";

// Global memory cache for loaded images
const imageCache = {};

// Helper function to preload an image
function preloadImage(src) {
  return new Promise((resolve) => {
    if (!src) return resolve();

    // If image is already cached, skip preload
    if (imageCache[src]) {
      resolve();
    } else {
      const img = new Image();
      img.onload = () => {
        imageCache[src] = true; // Cache it
        resolve();
      };
      img.src = src;
    }
  });
}

const FormFooter = ({ footer }) => {
  const [imageSrc, setImageSrc] = useState(footer?.icon);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!footer?.icon) return;

    setIsLoaded(false); // Reset fade animation

    // Preload the image and then show it
    preloadImage(footer.icon).then(() => {
      setImageSrc(footer.icon);
      setIsLoaded(true);
    });
  }, [footer]);

  return (
    <footer className="user_from__footer">
      <img
        src={imageSrc}
        alt="Footer Icon"
        className={`${footer.class || "questionmark-img"} ${
          isLoaded ? "fade-in" : "fade-out"
        }`}
        loading="eager"
      />

      {/* <a href="tel:+18772272872" className="support-btn">
        <span>📞 Want to talk now?</span>
      </a> */}

      <a href="tel:+18772272872" className="call-button" title="Call Now">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          fill="white"
          viewBox="0 0 24 24"
        >
          <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.11-.21c1.21.49 2.53.76 3.89.76a1 1 0 011 1V20a1 1 0 01-1 1c-9.39 0-17-7.61-17-17a1 1 0 011-1h3.5a1 1 0 011 1c0 1.36.26 2.68.76 3.89a1 1 0 01-.21 1.11l-2.2 2.2z" />
        </svg>
      </a>
    </footer>
  );
};

export default FormFooter;
